import {z} from 'zod';

export const CalculateFinancingFormSchema = z.object({
  financedValue: z.number().min(0),
  interestRate: z.number().min(0),
  expectedDaysInStock: z.number().min(0),
});

export type CalculateFinancingFormSchemaType = z.infer<typeof CalculateFinancingFormSchema>;
